(function () {
    'use strict';
    angular.module('Services').service('DownloadReportsSocketService', DownloadReportsSocketService);
    DownloadReportsSocketService.$inject = [
        '$cookies',
        'NotificationsService',
        '$q'
    ];

    function DownloadReportsSocketService(
        $cookies,
        NotificationsService,
        $q
    ) {
        let isConnected = false;
        let stompClient = {};

        function connect() {
            const defer = $q.defer();
            if (!isConnected) {
                const tokenData = angular.fromJson(localStorage.getItem('c_td'));
                const url = ApiURLs.shipment.shipmentSocketConnect;
                const socket = new WebSocket(url);
                const headers = {
                    passcode: tokenData['data']['access_token']
                };

                stompClient = Stomp.over(socket);
                stompClient.connect(headers, frame => {
                    stompClient.subscribe('/user/queue/admin/shipment-report', (res) => {
                        const data = angular.fromJson(res.body);
                        const timeStamp = new Date();

                        NotificationsService.addNotificationData({
                            id: timeStamp,
                            url: data.url,
                            message: 'CSV Report Ready',
                            time: timeStamp
                        });
                    });
                    stompClient.subscribe('/user/queue/admin/shipment-report-by-id', (res) => {
                        const data = angular.fromJson(res.body);
                        const timeStamp = new Date();

                        NotificationsService.addNotificationData({
                            id: timeStamp,
                            url: data.url,
                            message: 'CSV Report Ready',
                            time: timeStamp
                        });
                    });
                    stompClient.subscribe('/user/queue/errors', (res) => {
                        const data = angular.fromJson(res.body);
                        const timeStamp = new Date();

                        NotificationsService.addNotificationData({
                            id: timeStamp,
                            url: data.url,
                            isError: true,
                            message: `Can't download report`,
                            time: timeStamp
                        });
                    });
                    isConnected = true;
                    defer.resolve();
                }, error => {
                    console.log(error);
                    isConnected = false;
                    defer.reject();
                });
            } else {
                defer.resolve();
            }

            return defer.promise;
        }

        return {
            init: () => {
                connect();
            },
            downloadShipmentReport: (payload) => {
                if (!isConnected) {
                    connect().then(() => {
                        stompClient.send('/app/admin/shipment-report', {}, angular.toJson(payload));
                    });
                    return;
                }
                stompClient.send('/app/admin/shipment-report', {}, angular.toJson(payload));
            },
            downloadShipmentReportByIds: (payload) => {
                if (!isConnected) {
                    connect().then(() => {
                        stompClient.send('/app/admin/shipment-report-by-id', {}, angular.toJson(payload));
                    });
                    return;
                }
                stompClient.send('/app/admin/shipment-report-by-id', {}, angular.toJson(payload));
            },
            disconnect: () => {
                if (!isConnected) { return; }
                stompClient.disconnect(() => { console.log('Disconnected'); });
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/DownloadReportsSocketService.js